import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer');
const AuthenticationContainer = () =>
  import('@/containers/AuthenticationContainer');

// Dashboard Views
const Dashboard = () => import('@/views/Dashboard');
const MessageBox = () => import('@/views/MessageBox');
const SenderNames = () => import('@/views/SenderNames');
const Newsletter = () => import('@/views/Newsletter');
const BirthdayMessenger = () => import('@/views/BirthdayMessenger');
const SMSCollection = () => import('@/views/SMSCollection');
const ExtensibleSMS = () => import('@/views/ExtensibleSMS');

// Making Money
const AffiliateReferral = () => import('@/views/AffiliateReferral');
const AgentPartnership = () => import('@/views/AgentPartnership');
const ContentPublishing = () => import('@/views/ContentPublishing');

// Account Views
const PasswordReset = () => import('@/components/account/PasswordReset');
const ActivateAccount = () => import('@/components/account/ActivateAccount');
const Login = () => import('@/components/account/Login');
const Register = () => import('@/components/account/Register');
const Settings = () => import('@/views/Settings');
const ZigaUnits = () => import('@/views/ZigaUnits');
const ManageNewsletters = () => import('@/views/ManageNewsletters');

// STATISTICS VIEWS
const UnitsUsageHistory = () => import('@/components/ziga-units/UnitsHistory');

// Storage Service
import { StorageService } from '@/services/storage.service';

Vue.use(Router);

let router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            requiresAuth: true,
            title: 'Dashboard',
          },
        },
        {
          path: 'message-box',
          name: 'MessageBox',
          component: MessageBox,
          meta: {
            requiresAuth: true,
            title: 'Message Box',
          },
        },
        {
          path: 'sender-names',
          name: 'SenderNames',
          component: SenderNames,
          meta: {
            requiresAuth: true,
            title: 'Sender Names',
          },
        },
        {
          path: 'newsletter',
          name: 'SMS Newsletter',
          component: Newsletter,
          meta: {
            requiresAuth: true,
            title: 'SMS Newsletter',
          },
        },
        {
          path: 'birthday-messenger',
          name: 'Auto Birthday SMS',
          component: BirthdayMessenger,
          meta: {
            requiresAuth: true,
            title: 'Birthday Messenger',
          },
        },
        {
          path: 'sms-collection',
          name: 'SMS Collections',
          component: SMSCollection,
          meta: {
            requiresAuth: true,
            title: 'SMS Collections',
          },
        },
        {
          path: 'extensible-sms',
          name: 'Extensible SMS',
          component: ExtensibleSMS,
          meta: {
            requiresAuth: true,
            title: 'Extensible SMS',
          },
        },
        {
          path: 'affiliate-referral',
          name: 'Affiliate Referral',
          component: AffiliateReferral,
          meta: {
            requiresAuth: true,
            title: 'Affiliate Referral',
          },
        },
        {
          path: 'agent-partnership',
          name: 'Agent Partnership',
          component: AgentPartnership,
          meta: {
            requiresAuth: true,
            title: 'Agent Partnership',
          },
        },
        {
          path: 'content-publishing',
          name: 'Content Publishing',
          component: ContentPublishing,
          meta: {
            requiresAuth: true,
            title: 'Content Publishing',
          },
        },
        {
          path: 'account/settings',
          name: 'Settings',
          component: Settings,
          meta: {
            requiresAuth: true,
            title: 'Account Settings',
          },
        },
        {
          path: 'account/ziga-units',
          name: 'Ziga Units',
          component: ZigaUnits,
          meta: {
            requiresAuth: true,
            title: 'Ziga Units',
          },
        },
        {
          path: 'account/manage-newsletters',
          name: 'Manage Newsletters',
          component: ManageNewsletters,
          meta: {
            requiresAuth: true,
            title: 'Manage Newsletters',
          },
        },
      ],
    },
    {
      path: '/units-usage-history',
      name: 'UnitsUsageHistory',
      component: UnitsUsageHistory,
    },
    {
      path: '/account',
      redirect: '/account/login',
      name: 'Account',
      component: AuthenticationContainer,
      children: [
        {
          path: '/account/password-reset',
          name: 'Password Reset',
          component: PasswordReset,
          meta: {
            public: true,
            onlyWhenLoggedOut: true,
            title: 'Password Reset',
          },
        },
        {
          path: '/account/activate-account',
          name: 'Activate Account',
          component: ActivateAccount,
          meta: {
            requiresAuth: true,
            title: 'Activate Account',
          },
        },
        {
          path: '/account/login',
          name: 'Login',
          component: Login,
          meta: {
            public: true,
            onlyWhenLoggedOut: true,
            title: 'Login',
          },
        },
        {
          path: '/account/register',
          name: 'Register',
          component: Register,
          meta: {
            public: true,
            onlyWhenLoggedOut: true,
            title: 'Register',
          },
        },
      ],
    },
    // {
    //   path: '/account',
    //   redirect: '/account/login',
    //   name: 'Account',
    //   component: AuthenticationContainer,
    //   children: [
    //     {
    //       path: '/account/password-reset',
    //       name: 'Password Reset',
    //       component: PasswordReset,
    //       meta: {
    //         public: true,
    //         onlyWhenLoggedOut: true,
    //         title: 'Password Reset',
    //       },
    //     },
    //   ],
    // },
  ],
});

router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start();
  }
  next();
});

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some((record) => record.meta.public);
  const onlyWhenLoggedOut = to.matched.some(
    (record) => record.meta.onlyWhenLoggedOut
  );
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const loggedIn = !!StorageService.getToken();

  if (isPublic && onlyWhenLoggedOut && !loggedIn) {
    return next();
  }

  if (requiresAuth && !loggedIn) {
    return next({
      path: '/account/login',
      query: { redirect: to.fullPath },
    });
  }

  if (loggedIn && onlyWhenLoggedOut) {
    return next('/');
  }

  next();
});

router.afterEach((to, from) => {
  NProgress.done();
  Vue.nextTick(() => {
    document.title = 'Zigatext Messaging Platform :: ' + to.meta.title;
  });
});

export default router;
